import { ColorLayerData } from "../layers/colorLayerData.model.tsx";
import { BaseSerializer } from "./baseSerializer.ts";


export class ColorSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        this._normalizeSource(data)
        const gp = new ColorLayerData(data);
        console.log(gp);
        return gp;

    }

}
